import React from 'react';
import { Modal, designSystem } from '@yola/ws-ui';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const {
  IconButton,
  Box,
  Tag,
  Heading,
  Paragraph,
  ActionButton,
  HorizontalStack,
  Stack,
} = designSystem;

const SiteLimitModal = ({
  isDesktopView,
  isLoading,
  onClose,
  imageSrc,
  captions,
  onUpgrade,
  isPremium,
  onRedirectToDashboard,
}) => {
  const classes = classnames('ws-site-limit-dialog', {
    'ws-site-limit-dialog--desktop-view': isDesktopView,
  });

  const DynamicStack = isDesktopView ? HorizontalStack : Stack;

  return (
    <Modal
      className={classes}
      width={500}
      height={616}
      fullscreen={!isDesktopView}
      centered
      draggable={false}
      resizable={false}
      overlay="visible"
    >
      <div className="ws-site-limit-dialog__close-button">
        <IconButton
          glyph="close"
          iconPlacement="after"
          size="medium"
          onClick={onClose}
          transparent
          selected
        />
      </div>
      <img className="ws-site-limit-dialog__image" src={imageSrc} alt="" />
      <Box
        padding="spacing-m"
        breakpoints={{
          sm: {
            padding: 'spacing-xl',
            paddingTop: 'spacing-l',
          },
        }}
      >
        <div className="ws-site-limit-dialog__content">
          <div>
            <Box
              marginBottom="spacing-3-xs"
              breakpoints={{
                sm: {
                  marginBottom: 'spacing-2-xs',
                },
              }}
            >
              <Tag
                size="medium"
                appearance={isPremium ? 'white' : 'cta-secondary'}
                label={captions.limit}
              />
            </Box>

            <Box marginBottom="spacing-xs">
              <Heading type="heading-3">
                {isPremium ? captions.titlePremium : captions.title}
              </Heading>
            </Box>
            <Box marginBottom="spacing-m">
              <Paragraph size="large">
                {isPremium ? captions.descriptionPremium : captions.description}
              </Paragraph>
            </Box>
          </div>
          <div>
            <DynamicStack
              gap="spacing-xs"
              breakpoints={{
                sm: {
                  gap: 'spacing-m',
                },
              }}
            >
              {!isPremium && (
                <ActionButton
                  size="extra-large"
                  fontSize="large"
                  format="solid"
                  appearance="gradient"
                  label={captions.upgradeButton}
                  fullWidth={!isDesktopView}
                  onClick={onUpgrade}
                  isLoading={isLoading}
                />
              )}
              <ActionButton
                format={isPremium ? 'solid' : 'text'}
                size="extra-large"
                fontSize="large"
                label={captions.viewWebsitesButton}
                onClick={onRedirectToDashboard}
              />
            </DynamicStack>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

SiteLimitModal.propTypes = {
  captions: PropTypes.shape({
    limit: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    titlePremium: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    descriptionPremium: PropTypes.string.isRequired,
    viewWebsitesButton: PropTypes.string.isRequired,
    upgradeButton: PropTypes.string.isRequired,
  }).isRequired,
  isPremium: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isDesktopView: PropTypes.bool.isRequired,
  onUpgrade: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onRedirectToDashboard: PropTypes.func.isRequired,
};

export default SiteLimitModal;
